export class SamplingSimulationSubset {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestedFraction",
            "baseName": "requestedFraction",
            "type": "number",
            "format": "double"
        },
        {
            "name": "observedFraction",
            "baseName": "observedFraction",
            "type": "number",
            "format": "double"
        },
        {
            "name": "scannedRows",
            "baseName": "scannedRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "subjectRows",
            "baseName": "subjectRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tableTotalRows",
            "baseName": "tableTotalRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "scannedBytes",
            "baseName": "scannedBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SamplingSimulationSubset.attributeTypeMap;
    }
    constructor() {
    }
}
